// src/pages/AboutUsPage.js (or App.js)
import { React, useEffect, useState } from "react";
import { bandMembers } from "../data/bandMembersData";
import BandMembersCard from "../minicomponents/BandMembersCard";
// src/pages/AboutUsPage.js
import { useLocation } from "react-router-dom";

const MeetTheMembersPage = ({ t }) => {
  const location = useLocation();
  const [isHome, setIsHome] = useState(false);

  useEffect(() => {
    if (location.pathname.includes("home")) {
      setIsHome(true);
    }
  }, [location.pathname]);

  return (
    <div
      className={`
        min-h-screen text-gray-100 py-12 
        animate-shade-drift
        ${
          isHome
            ? ""
            : "[background-image:linear-gradient(to_right,theme(colors.black)_0%,theme(colors.gray.950)_50%,theme(colors.black)_100%)]"
        }
      `}
    >
      <header className="text-center mb-16 md:mb-24 relative z-10">
        <h1 className="alt-font text-5xl md:text-6xl font-bold text-white">
          {t("meetTheBand.header", "Meet The Band")}
        </h1>
        <p className="text-xl text-slate-400 mt-4">
          {t("meetTheBand.subtitle", "The artists behind the noise. Get to know us!")}
        </p>
      </header>
      <main className="container mx-auto max-w-6xl relative z-10 md:px-12 px-6">
        {bandMembers.map((member, index) => (
          <BandMembersCard
            key={member.id}
            member={member}
            reverseLayout={index % 2 !== 0}
            isHome={isHome}
            t={t}
          />
        ))}
      </main>

      {/* <footer className="text-center mt-24 py-8 border-t border-gray-800 relative z-10">
        <p className="text-gray-500">&copy; {new Date().getFullYear()} [Your Band Name]. Rock On!</p>
      </footer> */}
    </div>
  );
};

export default MeetTheMembersPage;
